import React, { useCallback, useEffect } from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  logoutInitiated,
  setConnectedFacebookPage, setConnectedGooglePage,
  setConnectedInstagramPage, setConnectedLinkedInPage, setPageIdentifiersForUser, setTokenChanged,
  setUser
} from '../store/common/common.actions'
import { setFacebookPage, setIGPage } from '../store/dashboard/dashboard.actions'
import { FacebookPage, InstagramPage } from '@3m5/sm_publish-frontend-api'
import { PageIdentifier } from '@professocialApi/professocial-core-frontend-api'
import { namedRequestData, namedRequestStatus } from '../store/common/common.selectors'
import { CoreRootState } from '../store/coreRoot.reducer'
import { ActionCall } from '@professocial/professocialTypes/types/commonTypes'

type Props = {
  proceedLogout: () => void
}

const LogOut: React.FC<Props> = (props) => {
  const dispatch = useDispatch()
  const dispatchLogOutUser = useCallback(() => dispatch(logoutInitiated()), [dispatch])
  const dispatchSetConnectedFacebookPage = useCallback((params: string) => dispatch(setConnectedFacebookPage(params)), [dispatch])
  const dispatchSetConnectedInstagramPage = useCallback((params: string) => dispatch(setConnectedInstagramPage(params)), [dispatch])
  const dispatchSetConnectedGooglePage = useCallback((params: string) => dispatch(setConnectedGooglePage(params)), [dispatch])
  const dispatchSetConnectedLinkedInPage = useCallback((params: string) => dispatch(setConnectedLinkedInPage(params)), [dispatch])
  const dispatchSetFacebookPage = useCallback((params: FacebookPage | undefined) => dispatch(setFacebookPage(params)), [dispatch])
  const dispatchSetInstagramPage = useCallback((params: InstagramPage | undefined) => dispatch(setIGPage(params)), [dispatch])
  const dispatchSetPageIdentifiersForUser = useCallback((params: PageIdentifier[] | undefined) => dispatch(setPageIdentifiersForUser(params)), [dispatch])
  const dispatchSetTokenChanged = useCallback((params: boolean) => dispatch(setTokenChanged(params)), [dispatch])

  const onLogOutUser: ActionCall | undefined = useSelector((state: CoreRootState) => namedRequestData(state, logoutInitiated.type))

  useEffect(() => {
    dispatchLogOutUser()
    dispatchSetFacebookPage(undefined)
    dispatchSetInstagramPage(undefined)
    dispatchSetPageIdentifiersForUser(undefined)
    dispatchSetTokenChanged(false)
    sessionStorage.removeItem('X-F2M-AuthToken')
    sessionStorage.removeItem('XSRF-TOKEN')
    localStorage.removeItem('user')
    dispatchSetConnectedFacebookPage('')
    dispatchSetConnectedInstagramPage('')
    dispatchSetConnectedGooglePage('')
    dispatchSetConnectedLinkedInPage('')
    props.proceedLogout()
  }, [])

  return (
    <>{onLogOutUser?.status === 'success' && <Redirect exact to='/login' />}</>
  )
}

export default LogOut
